<template>
	<b-modal
		ref="knifeHistoryModal"
		size="xmd"
		hide-footer
		:title="`Historial de Navaja | ${knife.code}-${knife.series}`"
		@hidden="handleCloseModal"
		scrollable
		no-close-on-backdrop
		no-close-on-esc
	>
		<div>
			<b-overlay :show="isLoading">
				<b-table-simple responsive sticky-header="60vh" no-border-collapse>
					<b-thead class="sticky-header" style="white-space: nowrap">
						<b-tr>
							<b-th v-for="field in fields" :key="field.key" :class="field.class">
								{{ field.label }}
							</b-th>
						</b-tr>
					</b-thead>
					<b-tbody>
						<template v-if="knives.length > 0">
							<b-tr v-for="(knive, index) in knives" :key="index">
								<b-td class="text-center">
									{{ knive.full_name }}
								</b-td>
								<b-td class="text-center">
									{{ knive.size }}
								</b-td>
								<b-td class="text-center">
									{{ knive.tournament }}
								</b-td>
								<b-td class="text-center">
									{{ knive.used_at | myGlobalDayWithHour }}
								</b-td>
								<b-td class="text-center">
									{{ knive.result ? knive.result.toUpperCase() : "-" }}
								</b-td>
							</b-tr>
						</template>
						<b-tr v-if="knives.length === 0">
							<b-td :colspan="fields.length" class="text-center">No hay registros para mostrar</b-td>
						</b-tr>
					</b-tbody>
				</b-table-simple>
			</b-overlay>
		</div>
	</b-modal>
</template>

<script>
import TournamentKnivesService from "@/views/brain/tournament/views/knives/services/tournament-knives.service.js"
export default {
	name: "KnifeHistoryModal",
	data: () => ({
		search: "",
		isLoading: false,
		fields: [
			{ key: "specimen", label: "Ejemplar", class: "text-center" },
			{ key: "size", label: "TAMAÑO(cm)", class: "text-center" },
			{ key: "tournament", label: "Torneo", class: "text-center" },
			{ key: "date", label: "Fecha", class: "text-center" },
			{ key: "result", label: "Resultado", class: "text-center" },
		],
		knives: [],
	}),
	computed: {},
	async mounted() {
		this.getKnifeHistory()
		this.$refs.knifeHistoryModal.toggle()
	},
	props: {
		knife: {
			type: Object,
			required: true,
		},
	},
	methods: {
		async getKnifeHistory() {
			try {
				this.isLoading = true
				console.log(this.knife)
				const { data } = await TournamentKnivesService.getHistory(this.knife.id)
				this.knives = data || []
			} catch (error) {
				console.error(`Error fetching knives:`, error)
			} finally {
				this.isLoading = false
			}
		},
		handleCloseModal() {
			this.$emit("close")
		},
	},
}
</script>
<style scoped></style>
